import React from 'react';

import ConfirmationBlob from '../../general/ConfirmationBlob';
import { STEP_COMPLETED_EMPTY_BLOB_TEST_ID } from '../constants';

interface Props {
  uncompleteStep(): Promise<void>;
}

const StepCompletedEmptyBlob: React.FC<Props> = ({ uncompleteStep }) => {
  return (
    <ConfirmationBlob
      title="No documents required"
      message="Based on your carrier selection, there are no additional documents required at this time. Select “BACK” below to continue with your enrollment checklist."
      btnText="Upload Documents"
      onConfirm={uncompleteStep}
      data-test-id={STEP_COMPLETED_EMPTY_BLOB_TEST_ID}
    />
  );
};

export default StepCompletedEmptyBlob;
